import { useState } from 'react'
import { Card, CardHeader, CardTitle, CardDescription, CardContent, Textarea } from '@/components/ui'
import { TextSelect } from 'lucide-react'
import { diffChars } from 'diff'

export function TextDiff() {
  const [text1, setText1] = useState('Hello world')
  const [text2, setText2] = useState('Hello there')
  const [diff, setDiff] = useState<any[]>([])

  const handleDiff = () => {
    setDiff(diffChars(text1, text2))
  }

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20">
            <TextSelect className="h-6 w-6 text-blue-500" />
          </div>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Text Diff</h1>
            <p className="text-muted-foreground">Compare two texts</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <Card className="glass">
          <CardHeader>
            <CardTitle>Text 1</CardTitle>
          </CardHeader>
          <CardContent>
            <Textarea
              value={text1}
              onChange={(e) => {
                setText1(e.target.value)
                handleDiff()
              }}
              className="h-48 font-mono"
            />
          </CardContent>
        </Card>
        <Card className="glass">
          <CardHeader>
            <CardTitle>Text 2</CardTitle>
          </CardHeader>
          <CardContent>
            <Textarea
              value={text2}
              onChange={(e) => {
                setText2(e.target.value)
                handleDiff()
              }}
              className="h-48 font-mono"
            />
          </CardContent>
        </Card>
      </div>

      <Card className="glass">
        <CardHeader>
          <CardTitle>Difference</CardTitle>
        </CardHeader>
        <CardContent>
          <pre className="font-mono p-4 bg-muted/30 rounded-lg">
            {diff.map((part, index) => {
              const color = part.added ? 'text-green-500' : part.removed ? 'text-red-500' : 'text-inherit'
              return <span key={index} className={color}>{part.value}</span>
            })}
          </pre>
        </CardContent>
      </Card>
    </div>
  )
}
